import React, { useState ,useEffect} from 'react';
import Sidebar from '.././components/sidebar'
import Footer from '.././components/footer'
import Head from '.././components/head'




export default function Main() {


  const boxes = [
    { title: "New Blogs", color: "primary", link: "/add-blogs" },

    { title: "All Blogs", color: "secondary", link: "/all-blogs" },
    { title: "New Hotel", color: "success", link: "/addhotel" },
    { title: "Hotels List", color: "danger", link: "/viewhotel" },
    { title: "New Packages", color: "warning", link: "/addpackage" },
    { title: "Package List", color: "info", link: "/listpackage" },
  ];


  return (
    <>
     <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
       
       <Head />
       
       <div className="page-content">
        
        

        {/* Start */}
        <div className="container mt-5">
      <div className="row g-4">
        {boxes.map((box, index) => (
          <div key={index} className="col-md-4">
            <a
              href={box.link}
              className={`card text-white bg-${box.color} text-center text-decoration-none shadow-lg`}
              style={{
                padding: "30px",
                borderRadius: "15px",
                transition: "transform 0.3s, box-shadow 0.3s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "120px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
              }}
            >
              <h5 className="card-title m-0">{box.title}</h5>
            </a>
          </div>
        ))}
      </div>
    </div>


        {/* End */}



      </div>


  
       
        <Footer/>
       
      </div>
    </div>
  </>

  )
}
